import React, { useState } from 'react';
import Select from 'react-select';


const SearchStrip = ({fromDate,toDate,setFromDate,setToDate,products,setProdID,calculateStocks,result,initiateSearch}) => {
  const productOptions = products?.map((i) => ({
    value: i._id,
    label: `${i.productName}-${i.sku}`,
  }));
  const productHandler = (options) => {
    const { value } = options;
    setProdID({ label: value });
  }


  const handleSearch = () => {
    // Trigger the search with the provided values
    // onSearch(searchCriteria);
    initiateSearch();


  };

 

  return (
    <div className="searchStripContainer">
    <div  className="searchStrip">
      
      <label>Search From Date</label>
      <input
        type="Date"
        value={fromDate}
        onChange={(e) => setFromDate(e.target.value)}
      />
      <label>To Date</label>
      <input
        type="Date"
        value={toDate}
        onChange={(e) => setToDate(e.target.value)} 
      />
      <button className="searchBtn" onClick={handleSearch}>Search</button>

    </div>
    <div className="searchStrip">
    
      <label>Select Product</label>
      <Select
              className='picker'
              required
              name='product'
              options={productOptions}
              onChange={productHandler}
            />
            <button className='calculateStockBtn' onClick={calculateStocks}>calculate Stock</button>
            <div>{result ?? 'n/a'}</div>       
    </div>

    </div>
  );
};

export default SearchStrip;
